// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
import "../stylesheets/active_admin";

import "@activeadmin/activeadmin";
import "@fortawesome/fontawesome-free/css/all.css";
import "activeadmin_addons";
import "arctic_admin";
import '../vendor/datepicker-pl';
import 'select2/dist/js/i18n/pl.js';
import "./scripts/location_external_data.js";
import "./scripts/activation_code_form.js";
import { subscribeInputs, hideInputs, deviceConfigAutocomplete, taxOfficeAutocomplete } from "./scripts/form_helpers";

window.onload = function() {
  $.fn.select2.defaults.set('language', document.documentElement.lang || 'en');

  if ($('.admin_device_configs').length != 0)  {
    $('.blank_slate a').hide();
  }

  dailyReportsWrapper();
  eReceiptWrapper();
  deviceConfigAutocomplete();
  taxOfficeAutocomplete();

  if ($('#edit_user').length == 0 && $("#new_user").length == 0) return;

  subscribeInputs();
  hideInputs();

  $('.has_many_add').on('click', function() {
    setTimeout(subscribeInputs, 50);
    setTimeout(hideInputs, 50);
  })
};

$(function () {
  let clear_btn = $('.clear_filters_btn');
  let submit_btn = $('.filter_form input[type="submit"]');

  clear_btn.on('click', function() {
    submit_btn.attr("disabled", true);
  });
  submit_btn.on('click', function() {
    clear_btn.removeClass('clear_filters_btn');
    clear_btn.removeAttr('href');
  });
});

function dailyReportsWrapper() {
  let btn = $('.btn-wrapper');
  let btnWrapper = $('#daily-reports-wrapper');
  let btnUnwrapper = $('#daily-reports-unwrapper');
  let jsonContainer = $('pre.container-wrapped');

  btn.on('click', () => {
    btnWrapper.toggle();
    btnUnwrapper.toggle();

    jsonContainer.toggleClass("container-wrapped container-unwrapped");
  });
}

function eReceiptWrapper() {
  let btnJwe = $('.btn-jwe-wrapper');
  let btnJws = $('.btn-jws-wrapper');
  let btnJweWrapper = $('#e-receipt-jwe-wrapper');
  let btnJweUnwrapper = $('#e-receipt-jwe-unwrapper');
  let btnJwsWrapper = $('#e-receipt-jws-wrapper');
  let btnJwsUnwrapper = $('#e-receipt-jws-unwrapper');
  let jweContainer = $('pre.container-wrapped');
  let jwsContainer = $('p.container-wrapped');

  btnJwe.on('click', () => {
    btnJweWrapper.toggle();
    btnJweUnwrapper.toggle();

    jweContainer.toggleClass("container-wrapped container-unwrapped");
  });

  btnJws.on('click', () => {
    btnJwsWrapper.toggle();
    btnJwsUnwrapper.toggle();

    jwsContainer.toggleClass("container-wrapped container-unwrapped");
  });
}
